import { store } from '@/Infrastructure/State';

import type { ICustomer } from '../../interfaces/src/integration/sfcc-shared';

import type { IActionObject } from './user.actions';
import { SET_CURRENT_USER } from './user.actions';

const defaultState: ICustomer = {
  id: '',
  customerNumber: '',
  externalId: '',
  email: '',
  firstName: '',
  middleName: '',
  lastName: '',
  dateOfBirth: '',
  addresses: [],
  defaultShippingAddressId: '',
  shippingAddressIds: [],
  defaultBillingAddressId: '',
  billingAddressIds: [],
  isEmailVerified: false,
  rut: '',
  originalRegistrationDate: '' as unknown as Date,
  enabled: false,
  migratedFromSalesforce: false,
  sendNotifications: false,
  acceptedTermsAndConditions: false,
  authType: 'guest',
  isUserActive: false
};

const userReducer = (
  state = defaultState,
  action: IActionObject<ICustomer>
): ICustomer => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return action.payload ? { ...state, ...action.payload } : state;
    default:
      return state;
  }
};

export const setCurrentUser = (customer: ICustomer | null): void => {
  store.dispatch({
    type: SET_CURRENT_USER,
    payload: customer || ({} as ICustomer)
  });
};

export const changeUserActiveStatus = (isUserActive = false): void => {
  store.dispatch({
    type: SET_CURRENT_USER,
    payload: {
      isUserActive
    }
  });
};

export const getIsUserActive = (): boolean => {
  return store.getState()?.user?.isUserActive || false;
};

export const getIsAuthenticated = (): boolean => {
  return (
    store.getState()?.user?.authType !== 'guest' || !!store.getState()?.user
  );
};

export const getCurrentCustomer = (): ICustomer => {
  return store.getState()?.user || null;
};

export const getDocumentType = (): string | undefined => {
  return store.getState()?.user?.documentType;
};

export default userReducer;
